import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import useStyles from './styles';
import { i18n } from "../../../translate/i18n";
import { priceLocale } from "../Forms/PaymentForm";

function PaymentDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { plan } = formValues;

  const newPlan = JSON.parse(plan);
  const { users, connections, price } = newPlan;
  return (
    <Grid item xs={12} sm={12}>
      <Typography variant="h6" gutterBottom className={classes.title}>
        {i18n.t("financial.checkout.planDetails")}
      </Typography>
      <Typography gutterBottom>{i18n.t("financial.checkout.usersLabel")}: {users}</Typography>
      <Typography gutterBottom>WhatsApp: {connections}</Typography>
      <Typography gutterBottom>{i18n.t("financial.checkout.billing")}</Typography>
      <Typography gutterBottom>Total: ${Number(price || 0).toLocaleString(priceLocale(), {minimumFractionDigits: 2})}</Typography>
    </Grid>
  );
}

export default PaymentDetails;
